import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ServiceModalAction } from '../../actions/ServiceModalAction';
import { Translate as t } from '../../config/Translate';

const IssueManagerSection = ({
	companyId,
	editable,
	userCombo,
	issueManagerIds,
	issueManagerList,
	GetIssueManagers,
	SetIssueManagers,
}) => {
	const [selectedUser, setSelectedUser] = useState('');

	useEffect(() => {
		if (companyId) {
			GetIssueManagers(companyId);
		}
	}, [companyId]);

	const handleAdd = () => {
		if (!selectedUser || issueManagerIds.includes(selectedUser)) return;
		const updated = [...issueManagerIds, selectedUser];
		SetIssueManagers(companyId, updated);
		setSelectedUser('');
	};

	const handleRemove = (adminid) => {
		const updated = issueManagerIds.filter(id => id !== adminid);
		SetIssueManagers(companyId, updated);
	};

	const availableUsers = (userCombo || [])
		.filter(u => !issueManagerIds.includes(u.code))
		.sort((a, b) => (a.title || '').localeCompare(b.title || ''));

	return (
		<div className="card mb-2">
			<div className="card-header fw-bold">{t('service.issueManager.issueManagerSettings')}</div>
			<div className="card-body">
				<p className="text-muted mb-2" style={{ fontSize: '13px' }}>
					{t('service.issueManager.issueManagerDesc')}
				</p>

				{issueManagerIds.length === 0 && (
					<div className="text-muted mb-2" style={{ fontSize: '13px' }}>
						{t('service.issueManager.noIssueManagers')}
					</div>
				)}

				{issueManagerIds.length > 0 && (
					<table className="table table-sm table-bordered mb-2">
						<thead className="table-light">
							<tr>
								<th>{t('service.issueManager.managerName')}</th>
								<th style={{ width: '80px' }}></th>
							</tr>
						</thead>
						<tbody>
							{issueManagerIds.map(adminid => {
								const manager = issueManagerList.find(m => m.adminid === adminid);
								const fromCombo = (userCombo || []).find(u => u.code === adminid);
								const displayName = manager?.name || fromCombo?.title || adminid;
								return (
									<tr key={adminid}>
										<td>{displayName}</td>
										<td className="text-center">
											{editable && (
												<button
													className="btn btn-outline-danger btn-sm"
													onClick={() => handleRemove(adminid)}
													title={t('service.issueManager.remove')}
												>
													<ion-icon name="trash-outline"></ion-icon>
												</button>
											)}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				)}

				{editable && (
					<div className="d-flex gap-2 align-items-end">
						<select
							className="form-select form-select-sm"
							style={{ maxWidth: '300px' }}
							value={selectedUser}
							onChange={(e) => setSelectedUser(e.target.value)}
						>
							<option value="">{t('service.issueManager.selectManager')}</option>
							{availableUsers.map(u => (
								<option key={u.code} value={u.code}>{u.title}</option>
							))}
						</select>
						<button
							className="btn btn-primary btn-sm"
							onClick={handleAdd}
							disabled={!selectedUser}
						>
							{t('service.issueManager.addManager')}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

const mapState = (state) => ({
	issueManagerIds: state.ServiceModalReducer.issueManagerIds,
	issueManagerList: state.ServiceModalReducer.issueManagerList,
});

const mapDispatch = (dispatch) => ({
	GetIssueManagers: (companyId) => dispatch(ServiceModalAction.GetIssueManagers(companyId)),
	SetIssueManagers: (companyId, ids) => dispatch(ServiceModalAction.SetIssueManagers(companyId, ids)),
});

export default connect(mapState, mapDispatch)(IssueManagerSection);
